export enum DayOfWeek
{
  Sunday ,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}